/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Extension_Herotitleaccent2Inputs */

const he_extension_herotitleaccent2 = /** @type {(inputs: Extension_Herotitleaccent2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Extension`)
};

const en_extension_herotitleaccent2 = /** @type {(inputs: Extension_Herotitleaccent2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Extension`)
};

/**
* | output |
* | --- |
* | "Extension" |
*
* @param {Extension_Herotitleaccent2Inputs} inputs
* @param {{ locale?: "he" | "en" }} options
* @returns {LocalizedString}
*/
const extension_herotitleaccent2 = /** @type {((inputs?: Extension_Herotitleaccent2Inputs, options?: { locale?: "he" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Extension_Herotitleaccent2Inputs, { locale?: "he" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "he") return he_extension_herotitleaccent2(inputs)
	return en_extension_herotitleaccent2(inputs)
});
export { extension_herotitleaccent2 as "extension_heroTitleAccent" }